exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":root{--bolus-stroke:1}.diabetes--basalScheduledFill--1fJlr{fill:var(--basal);fill-opacity:.4}.diabetes--basalTempFill--3zEDj{fill:var(--basal);fill-opacity:.2}.diabetes--basalScheduledPath--1iW1-{stroke:var(--basal)}.diabetes--basalUndeliveredPath--2V6wR{stroke-dasharray:1.5,3}.diabetes--bgLow---sH-f{color:var(--bg-low);fill:var(--bg-low)}.diabetes--bgTarget--3eoZO{color:var(--bg-target);fill:var(--bg-target)}.diabetes--bgHigh--33Mni{color:var(--bg-high);fill:var(--bg-high)}.diabetes--bolusDelivered--3czCX{color:var(--bolus);fill:var(--bolus)}.diabetes--bolusInterrupted--165Yp{color:var(--bolus--interrupted);fill:var(--bolus--interrupted)}.diabetes--bolusProgrammed--1f3B_{fill:none;stroke:var(--bolus);stroke-dasharray:3,2;stroke-width:var(--bolus-stroke)}.diabetes--bolusRideTriangle--11jMx{fill:var(--bolus--ride)}.diabetes--bolusUndelivered--3KfBW,.diabetes--bolusUnderride--h-R0D{color:var(--bolus--undelivered);fill:var(--bolus--undelivered)}.diabetes--carbs--3fKj2{color:var(--carbs);fill:var(--carbs)}", ""]);

// exports
exports.locals = {
	"basalScheduledFill": "diabetes--basalScheduledFill--1fJlr",
	"basalTempFill": "diabetes--basalTempFill--3zEDj",
	"basalScheduledPath": "diabetes--basalScheduledPath--1iW1-",
	"basalUndeliveredPath": "diabetes--basalUndeliveredPath--2V6wR diabetes--basalScheduledPath--1iW1-",
	"bgLow": "diabetes--bgLow---sH-f",
	"bgTarget": "diabetes--bgTarget--3eoZO",
	"bgHigh": "diabetes--bgHigh--33Mni",
	"bolusDelivered": "diabetes--bolusDelivered--3czCX",
	"bolusInterrupted": "diabetes--bolusInterrupted--165Yp",
	"bolusProgrammed": "diabetes--bolusProgrammed--1f3B_",
	"bolusRideTriangle": "diabetes--bolusRideTriangle--11jMx",
	"bolusUndelivered": "diabetes--bolusUndelivered--3KfBW",
	"bolusUnderride": "diabetes--bolusUnderride--h-R0D",
	"carbs": "diabetes--carbs--3fKj2"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/styles/diabetes.css
 ** module id = 122
 ** module chunks = 0
 **/